import { InternalAxiosRequestConfig } from 'axios';
import Cookies from 'js-cookie';

export const setCookiesToHeaders = (config: InternalAxiosRequestConfig) => {
  const cookies = Object.entries(Cookies.get());
  cookies.forEach(([name, value]) => (config.headers[name] = value));
  return config;
};
